import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const StyledUl = styled.ul`
  display: grid;

  /**
  * minmax stops content blowout.
  * without it some of the columns may be larger than others
  */
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-rows: 1fr;
  grid-column-gap: ${spacing.plusQuarter};
  grid-row-gap: ${spacing.plusQuarter};
  grid-auto-flow: row;
  @media (max-width: 1350px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 930px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 620px) {
    grid-template-columns: 1fr;
  }
  margin-bottom: ${spacing.plusQuarter};
  padding: 0;
`;
